import React from 'react';
import HeadingDescription from '../HeadingDescription';
import TechnicalDataTable from '../TechnicalDataTable';
import PointersWithoutHeading from '../PointersWithoutHeading';
import OptiMove_CR08 from '../../assets/proposalImages/OptiMove_CR08.png';
import ZA10_18_Reciprocator from '../../assets/proposalImages/ZA10_18_Reciprocator.png';
import trolley from '../../assets/proposalImages/trolley.png';
import ProposalImage from '../ProposalImage';


export default function GemaSectionPart2({ gema }) {
  if (!gema) return null;
  if(!gema?.reciprocator && !gema?.trolley_for_manual_displacement_of_one_reciprocator && !gema?.reciprocator_control_unit && !gema?.gun_supports) return null;

  return (<>

    <div className="a4-paddings quotation-page quotation-page-compact">
      <div className="quotation-page-inner quotation-bg-light">
        <div className="quotation-section-block">
          <HeadingDescription heading="Reciprocators and Automation Equipment" description={""} level={3} />
        </div>
        {gema?.reciprocator && (
          <div className="quotation-section-block">
            <HeadingDescription heading="ZA10-18 Reciprocator" description={gema.reciprocator.description} level={3} />
            {gema.reciprocator.items && gema.reciprocator.items.length > 0 && (
              <PointersWithoutHeading items={gema.reciprocator.items} />
            )}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: true ? '1fr auto' : '1fr',
                gap: 20,
                alignItems: 'center',
              }}
            >


              {gema.reciprocator.technical_data?.data && (
                <TechnicalDataTable data={gema.reciprocator.technical_data.data} title="Technical data" />
              )}
              <ProposalImage src={ZA10_18_Reciprocator} wrapperStyle={{ marginBottom: 20 }} imgStyle={{ width: "68%" }} />

            </div>
          </div>
        )}
        {gema?.trolley_for_manual_displacement_of_one_reciprocator && (
          <div className="quotation-section-block">
            <HeadingDescription heading="Trolley for manual displacement of one reciprocator" description={gema.trolley_for_manual_displacement_of_one_reciprocator.description} level={3} />
            {gema.trolley_for_manual_displacement_of_one_reciprocator.items && gema.trolley_for_manual_displacement_of_one_reciprocator.items.length > 0 && (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: 20,
                  alignItems: 'center',
                  justifyContent: "space-between"
                }}
              >
                <PointersWithoutHeading items={gema.trolley_for_manual_displacement_of_one_reciprocator.items} />
                <ProposalImage src={trolley} wrapperStyle={{ marginBottom: 20 }} imgStyle={{ width: "100%" , marginRight: 120 }} />

              </div>
            )}
          </div>
        )}

      </div>
    </div>
    <div className="a4-paddings quotation-page quotation-page-compact">
      <div className="quotation-page-inner quotation-bg-light">
        {gema?.reciprocator_control_unit && (
          <div className="quotation-section-block">
            <HeadingDescription heading="3. OptiMove CR08 reciprocator control unit" description={gema.reciprocator_control_unit.description} level={3} />
            <ProposalImage src={OptiMove_CR08} wrapperStyle={{ marginBottom: 20 }} imgStyle={{ width: "68%" }} />

            {gema.reciprocator_control_unit.items && gema.reciprocator_control_unit.items.length > 0 && (
              <PointersWithoutHeading items={gema.reciprocator_control_unit.items} />
            )}
            {gema.reciprocator_control_unit.technical_data?.data && (
              <TechnicalDataTable data={gema.reciprocator_control_unit.technical_data.data} title="Technical data" />
            )}
          </div>
        )}
        {gema?.gun_supports && (
          <div className="quotation-section-block">
            <HeadingDescription heading="4. Gun supports" description={gema.gun_supports.description} level={3} />
          </div>
        )}
        <div className="quotation-section-block">
          <HeadingDescription
            heading={gema?.installation_training?.title || "Installation and Training"}
            description={gema?.installation_training?.description}
            level={3}
          />
          {gema?.installation_training?.items?.length > 0 ? (
            <PointersWithoutHeading items={gema.installation_training.items} />
          ) : (
            <p style={{ fontSize: 13, color: '#333', lineHeight: 1.6, margin: 0 }}>
              Start-up and training with a specialized Gema engineer.
            </p>
          )}
        </div>
      </div>
    </div>
  </>
  );
}
